module.exports = __webpack_public_path__ + "img/slide3-ru.6cf26b86.png";